module.exports = __webpack_public_path__ + "static/media/maintenance_icon_orange.59bb1e59.svg";